import { APP_PATH_RULES } from '../constants/application-types.constants'

export const checkConsultAnswers = (estado, consulta, homeData) => {
  let flowType = 'none'
  for (let key in APP_PATH_RULES) {
    const path = APP_PATH_RULES[key]
    if (path.condition({ homeData, consulta })) {
      flowType = path.id
      break
    }
  }

  return {
    ...homeData,
    ...consulta,
    estado,
    flowType,
  }
}
